import { LanguageService } from './services';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { PagesModule } from './modules';

@Component({
  standalone: true,
  imports: [RouterModule, HeaderComponent, FooterComponent, PagesModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'fe-ezset';
  constructor(private languageService: LanguageService) {}
}
